import React, { useState } from "react";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    alert("Thank you for contacting us! We'll get back to you soon.");
    setFormData({ name: "", email: "", phone: "", subject: "", message: "" });
  };

  return (
    <div className="contact-page">
      <div className="page-header">
        <h1>Get In Touch</h1>
        <p>We're here to help and answer any question you might have</p>
      </div>

      <div className="container">
        <div className="contact-content">
          <div className="contact-form-section">
            <h2>Send us a Message</h2>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Full Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Your name"
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your@email.com"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="+92 300 0000000"
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder="How can we help?"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Tell us more about your inquiry..."
                ></textarea>
              </div>

              <button type="submit" className="btn-submit">Send Message</button>
            </form>
          </div>

          <div className="contact-info-section">
            <h2>Contact Information</h2>

            <div className="info-card">
              <h3>📍 Address</h3>
              <p>
                Samsung Door-Step<br />
                123 Electronics Avenue<br />
                Lahore, Pakistan
              </p>
            </div>

            <div className="info-card">
              <h3>📞 Phone</h3>
              <p>
                Customer Support: <a href="tel:+923292737737">+92 (329) 273-7737</a><br />
                Sales: <a href="tel:+923292737737">+92 (329) 273-7737</a><br />
                Monday - Friday: 9 AM - 6 PM
              </p>
            </div>

            <div className="info-card">
              <h3>📧 Email</h3>
              <p>
                General: <a href="mailto:info@samsungdoorstep.pk">info@samsungdoorstep.pk</a><br />
                Support: <a href="mailto:support@samsungdoorstep.pk">support@samsungdoorstep.pk</a><br />
                Sales: <a href="mailto:sales@samsungdoorstep.pk">sales@samsungdoorstep.pk</a>
              </p>
            </div>

            <div className="info-card">
              <h3>🕐 Business Hours</h3>
              <p>
                Monday - Friday: 9:00 AM - 6:00 PM<br />
                Saturday: 10:00 AM - 4:00 PM<br />
                Sunday: Closed<br />
                <strong>Holidays: Closed</strong>
              </p>
            </div>

            <div className="social-links">
              <h3>Follow Us</h3>
              <div className="social-icons">
                <a href="https://www.facebook.com/share/17zVP3XP14/" target="_blank" rel="noopener noreferrer" title="Facebook">f</a>
                <a href="https://www.instagram.com/invites/contact/?utm_source=ig_contact_invite&utm_medium=copy_link&utm_content=10sgbb32" target="_blank" rel="noopener noreferrer" title="Instagram">ig</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
